export enum FunctionName {
  ClassifyMessage = 'classifyMessage',
  ProcessMessageConversion = 'processMessageConversion',
  ClassifyEmail = 'classifyEmail',
  ClassifyEmailMatched = 'classifyEmailMatched',
  ProcessConversion = 'processConversion',
  UpdateConversion = 'updateConversion',
  ToContactMessage = 'toContactMessage',
}
